import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { order } from "../states/atoms/order";
import {
  Header,
  MainDetails,
  ClientDetails,
  Dates,
  Table,
  Footer,
} from "../components";
import QRCode from "qrcode";
import ReactToPrint from "react-to-print";
import { API_BASE_URL, BASE_URL } from "../constant";
import { EmailShareButton } from "react-share";
import { useTranslation } from "react-i18next";

function Invoice({ id }) {
  const moment = require("moment");

  const componentRef = useRef();
  const [_QRCode, setQrCode] = useState(null);
  const [total, setTotal] = useState(0.0);
  const [orderDetails, setOrderDetails] = useState(order);

  const [wilaya, setWilaya] = useState("");
  const [address, setAddress] = useState(
    "Zone d'activité, Route de M'Sila\n" + "34000 Bordj-Bou-Arréridj"
  );

  const handlePrint = () => {
    window.print();
  };

  const [isLoading, setLoading] = useState(true);

  async function fetchData() {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}api/orders/${id}`);
      setOrderDetails(res.data);

      // Calculate the total after the order details are set
      let sum = 0.0;
      res.data.orderDetails.forEach((order) => {
        const amount = order.price * order.quantity;
        sum += amount;
      });
      setTotal(sum);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    generateQrCode();
  }, []); // Removed 'total' from the dependency array

  function generateQrCode() {
    QRCode.toDataURL(
      `${BASE_URL}/invoice/${id}`,
      { version: 5 },
      (err, url) => {
        if (err) {
          console.error(err);
        } else {
          setQrCode(url);
        }
      }
    );
  }

  const { t, i18n } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex justify-center h-full w-full text-center">
        <h1>chargement ...</h1>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 sm:p-8 md:p-16">
      <div className="bg-white pt-4">
        <div
          className={`flex gap-4 ${
            i18n.language === "ar" ? "flex-row-reverse" : ""
          }`}
        >
          <ReactToPrint
            documentTitle="Facture-proforma.pdf"
            trigger={() => (
              <button className="bg-primary-color mt-5 text-white font-bold py-2 px-4 sm:px-8 rounded shadow border-2 border-primary-color hover:bg-transparent hover:text-primary-color transition-all duration-300">
                {t("invoice.print")}
              </button>
            )}
            content={() => componentRef.current}
          />
          <EmailShareButton
            className="bg-primary-color mt-5 text-white font-bold py-2 px-4 sm:px-8 rounded shadow border-2 border-primary-color hover:bg-transparent hover:text-primary-color transition-all duration-300"
            subject="Facture Proforma"
            body={`Bonjour\nVous trouverez dans ce lien la facture proforma: ${document.URL}.\nCordialement.`}
          >
            {t("invoice.share")}
          </EmailShareButton>
        </div>

        <div ref={componentRef} className="my-4">
          <Header handlePrint={handlePrint} />
          <MainDetails
            wilaya={orderDetails?.wilaya}
            number={orderDetails?.orderNumber}
            date={orderDetails?.createdDate}
          />

          <ClientDetails
            clientName={orderDetails?.client?.firstName}
            clientAddress={orderDetails?.client?.address}
            clientWilaya={orderDetails?.wilaya}
            clientEmail={orderDetails?.client?.email}
            clientPhone={orderDetails?.client?.mobile}
            qrCode={_QRCode}
          />
          <Dates
            invoiceNumber={id}
            invoiceDate={moment(orderDetails?.createdDate).format(
              "DD/MM/YYYY"
            )}
            dueDate={moment(orderDetails?.createdDate)
              .add(10, "days")
              .format("DD/MM/YYYY")}
          />

          <Table
            id={orderDetails?.id}
            product={orderDetails?.product}
            quantity={orderDetails?.quantity}
            price={orderDetails?.price}
            description={orderDetails?.name}
            list={orderDetails?.orderDetails}
          />
          <Footer
            CapitalSocial=" 4 277 000 000 DA - "
            CompteBancaire="00200058580586215601 BEA AGENCE DE BBA | 020 00341412 2962002 49 NATIXIS BBA R.C N° 0462772B02 - Art. imp N° 34014203792 - NIS 000234010086358 -"
            NIF=" 000 234 046 277 228"
            total={total}
          />
        </div>
      </div>
    </div>
  );
}

export default Invoice;
